import { render, staticRenderFns } from "./gc-popup-almondco-despatch-data.vue?vue&type=template&id=7982ca88"
import script from "./gc-popup-almondco-despatch-data.vue?vue&type=script&lang=js"
export * from "./gc-popup-almondco-despatch-data.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-almondco-despatch-data.vue?vue&type=style&index=0&id=7982ca88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports